import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { lineStringSchema } from "../geojson";
import { paginatedSchema } from "../pagination";

import { baseAssetSchema } from "./assetsBase";

export const leveeCrossSectionListItemSchema = baseAssetSchema.extend({
  geometry: lineStringSchema.nullable(),
  levee: z.string().nullable() /* URL */,
  name: z.string(),
  distance_to_reference: z.number().nullable(),
  num_timeseries: z.number(),
});

export type LeveeCrossSectionListItem = z.infer<typeof leveeCrossSectionListItemSchema>;

export const leveeCrossSectionListSchema = paginatedSchema(leveeCrossSectionListItemSchema);
export type LeveeCrossSectionList = z.infer<typeof leveeCrossSectionListSchema>;

export const leveeCrossSectionSchema = leveeCrossSectionListItemSchema;
export type LeveeCrossSection = z.infer<typeof leveeCrossSectionSchema>;

export function useLeveeCrossSections(params = {}) {
  const url = combineUrlAndParams("/api/v4/leveecrosssections/", params);
  return useParsedQuery<LeveeCrossSectionList>(
    ["lizard-api-v4", "leveecrosssections", url],
    () => fetchWithError(url),
    (json: unknown) => leveeCrossSectionListSchema.parse(json)
  );
}

export function useLeveeCrossSection(id: number) {
  return useParsedQuery<LeveeCrossSection>(
    ["lizard-api-v4", "leveeCrossSections", id],
    () => fetchWithError(`/api/v4/leveecrosssections/${id}/`),
    (json: unknown) => leveeCrossSectionSchema.parse(json)
  );
}

export function useMultipleLeveeCrossSections(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "leveecrosssections", id],
        fetchFunction: () => fetchWithError(`/api/v4/leveecrosssections/${id}/`),
        parseFunction: (json: unknown) => leveeCrossSectionSchema.parse(json),
      };
    })
  );
}
